<template>
  <div class="icons-content">
    <div v-if="isloading" class="loading">
      <a-spin :spinning="isloading" />
    </div>
    <template v-else>
      <div
        class="icons-content-item"
        :class="{active: item.icon_url === currentIcon}"
        v-for="(item, index) in allHotIcon"
        :key="index"
        @click="onSelectIcon(item)"
      >
        <img :src="item.thumb_path" />
      </div>
    </template>
  </div>
</template>

<script>
import { getAllIcons } from "@/api/work";
export default {
  props: { currentIcon: { type: String } , type: { type: Number,default:1}},
  data() {
    return {
      isloading: false,
      allHotIcon: [],
    };
  },
  created() {
    // 獲取熱點圖表
    this.isloading = true;
    getAllIcons({ type: this.type })
      .then((res) => {
        this.allHotIcon = res.data;
        this.isloading = false;
      })
      .catch((err) => {
        console.log(err);
        this.isloading = false;
      });
  },
  methods: {
    onSelectIcon(item) {
      this.$emit("onSelectIcon", item);
    },
  },
};
</script>

<style lang="less" scoped>
.icons-content {
  padding: 0 4px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.icons-content-item {
  margin-right: 10px;
  padding: 4px;
  cursor: pointer;
  border: 1px solid transparent;
}
.icons-content-item img {
  width: 32px;
  height: 32px;
}
.active {
  border: 1px solid rgba(0,0,0,.1);
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 1px 0 rgba(255,255,255,.05);
}
.loading {
  text-align: center;
  width: 100%;
}
</style>